import { Entry } from '../Entry'

export function Entry20250806() {
  return (
    <Entry title="2025 Aug 6 - v3.10.17">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/17975/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
